import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import userPlaceholder from "../../../assets/images/placeholder.jpg";
import axios from "axios";
import cookie from "js-cookie";
import { toast } from "react-toastify";
import Loader from "../../../components/shared/Loader";
import { updateMeta } from "../../../store/actions/metaAction";

const ReasonsShow = ({ match }) => {
	const {
		params: { reasonID },
	} = match;

	const auth = useSelector(state => state.auth.user);
	const [picture, setPicture] = useState(userPlaceholder);
	const [pictureName, setPictureName] = useState(userPlaceholder);
	const [loading, setLoading] = useState(true);
	const [title, setTitle] = useState("");
	const [text, setText] = useState("");
	const dispatch = useDispatch();

	useEffect(() => {
		onStart();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const onStart = () => {
		dispatch(
			updateMeta({
				title: "تعديل تفاصيل العنصر",
				breadcrumb: "التوظيف",
				button: {
					show: false,
					text: null,
					link: null,
				},
			})
		);
		axios
			.get(`${process.env.REACT_APP_API_URL}/posts/${reasonID}`, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
				},
			})
			.then(function (response) {
				setTitle(response.data.data.data.title);
				setText(response.data.data.data.small_description);
				setPicture(
					`${process.env.REACT_APP_MAIN_URL}${response.data.data.data.icon}`
				);
				setPictureName(response.data.data.data.icon);
				setLoading(false);
			})
			.catch(function (error) {
				toast.error("خطأ، برجاء المحاولة لاحقا!");
			});
	};

	const handlePicture = () => {
		const fileInput = document.querySelector("#picture");
		setPicture(URL.createObjectURL(fileInput.files[0]));
	};

	const handleSubmit = e => {
		e.preventDefault();
		setLoading(true);
		const image = document.querySelector("#picture");
		if (image.files[0]) {
			const data = new FormData();
			data.append("file", image.files[0]);
			axios
				.post(`${process.env.REACT_APP_API_URL}/upload`, data, {
					headers: {
						Authorization: `Bearer ${cookie.get("token")}`,
						Accept: "application/json",
						"Content-Type": "multipart/form-data",
					},
				})
				.then(response => {
					const data = {
						title: title,
						small_description: text,
						icon: response.data.data.name,
					};
					axios
						.put(
							`${process.env.REACT_APP_API_URL}/posts/${reasonID}`,
							{
								admin_id: auth.data.id,
								category_id: 10,
								data: data,
							},
							{
								headers: {
									Authorization: `Bearer ${cookie.get("token")}`,
									Accept: "application/json",
								},
							}
						)
						.then(function (response) {
							toast.success("تم تحديث السبب بنجاح!");
							setLoading(false);
						})
						.catch(function (error) {
							toast.error("خطأ، برجاء المحاولة مره اخرى!");
							setLoading(false);
						});
				})
				.catch(error => {
					toast.error("خطأ في رفع الصورة، برجاء المحاولة مرة أخرى!");
					setLoading(false);
				});
		} else {
			const data = {
				title: title,
				small_description: text,
				icon: pictureName,
			};
			axios
				.put(
					`${process.env.REACT_APP_API_URL}/posts/${reasonID}`,
					{
						admin_id: auth.data.id,
						category_id: 10,
						data: data,
					},
					{
						headers: {
							Authorization: `Bearer ${cookie.get("token")}`,
							Accept: "application/json",
						},
					}
				)
				.then(function (response) {
					toast.success("تم تحديث السبب بنجاح!");
					setLoading(false);
				})
				.catch(function (error) {
					toast.error("خطأ، برجاء المحاولة مره اخرى!");
					setLoading(false);
				});
		}
	};

	return (
		<section>
			{loading && <Loader />}
			<form onSubmit={handleSubmit}>
				<div className="row">
					<div className="col-md-9">
						<div className="card">
							<div className="card-body">
								<div className="form-item">
									<label htmlFor="name">العنوان</label>
									<input
										type="text"
										id="name"
										required
										onChange={e => setTitle(e.target.value)}
										value={title}
									/>
								</div>
								<div className="form-item">
									<label htmlFor="name">الوصف</label>
									<input
										type="text"
										id="name"
										required
										onChange={e => setText(e.target.value)}
										value={text}
									/>
								</div>
							</div>
						</div>
					</div>
					<div className="col-md-3">
						<div className="card">
							<div className="card-body">
								<div className="form-item">
									<input type="file" onChange={handlePicture} id="picture" />
									<img src={picture} alt="avatar" className="imagePreview" />
								</div>
							</div>
						</div>
						<div className="form-item mt-3">
							<button className="bt bt-success btn-block">ارسال</button>
						</div>
					</div>
				</div>
			</form>
		</section>
	);
};

export default ReasonsShow;
